import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import SurveySection from '../components/involvement/SurveySection';
import SNSShareSection from '../components/involvement/SNSShareSection';
import VolunteerSection from '../components/involvement/VolunteerSection';
import './InvolvementPage.css';

const InvolvementPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <main>
        <section className="involvement-hero">
          <div className="container">
            <h1>Get Involved</h1>
            <p>{t('involvement.hero.subtitle')}</p>
          </div>
        </section>

        <div className="involvement-sections">
          <div className="container">
            <SurveySection />
            <SNSShareSection />
          </div>
        </div>

        <VolunteerSection />
      </main>
      <Footer />
    </>
  );
};

export default InvolvementPage;
